module.exports = "/assets/data/6437be519beebce74864cf24abc3fa60-NE21.data.json";